export const getQueryVariable = (variable, searchparam) => {
    const vars = searchparam.split("&");
    for (let i = 0; i < vars.length; i++) {
      const pair = vars[i].split("=");
      if (pair[0] === variable) { return pair[1]; }
    }
    return (false);
  };